'use-client';
import classnames from 'clsx';
import * as React from 'react';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import semanticClassNames from '../../../Container.semanticClassNames';
import styles from './PhotoArea.scss';

const PhotoArea: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return (
    <ContainerLogic
      {...props}
      ref={ref}
      className={classnames(styles.root, props.className)}
      renderSlot={({ containerChildren }) => (
        <>
          <div className={styles.shadowImgTL}></div>
          <div className={styles.shadowImgTR}></div>
          <div className={styles.shadowImgBL}></div>
          <div className={styles.shadowImgBR}></div>
          <div
            className={classnames(
              styles.bg,
              formatClassNames(
                semanticClassNames.root,
                ...(props.customClassNames || []),
              ),
            )}
          />
          {containerChildren}
        </>
      )}
    />
  );
};

export default React.forwardRef(PhotoArea);
